import { Navigate } from "react-router-dom";
import AuthService from '../Auth';

const PrivateRoute = ({ menu = 'default', privilegio = 'basic', location, children }) => {

    const isAuthenticated = () => {
        return AuthService.isLoggedIn();
    }

    const hasPermission = (menu, privilegio) => {
        return AuthService.verifyPrivilegio(menu, privilegio) || (menu === "default" && privilegio === 'basic');
    }

    if (isAuthenticated()) {
        if (hasPermission(menu, privilegio)) {
            return <>{children}</>;
        } else {
            return <Navigate to={{ pathname: "/401", state: { from: location } }} replace />;
        }
    }
    return <Navigate to={{ pathname: "/login", state: { from: location } }} replace />;

}

export default PrivateRoute;